import React, { Fragment, useEffect, useState } from 'react'
import { orderBy, State } from '@progress/kendo-data-query'
import { GridColumn as Column, Grid, GridSortChangeEvent } from '@progress/kendo-react-grid'
import { TradingAccountDto } from 'api/Clients/Types/TradingAccount'
import { PageData } from 'api/Pagination/Types'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import { Spinner } from 'components/Spinner'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { TableWithExport } from 'utils/table/withExport'

import clientDetailsTradingAccountWalletDetailsColumn from '../Clients/Details/clientDetailsTradingAccountWalletDetailsColumn'
import { WalletNavigation, WalletTab } from './Navigation/WalletNavigation'

import './Wallets.scss'

interface Props {
  data: WalletDto
}

export const TradingAccountTable: React.FC<Props> = ({ data }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const [isLoading, setLoading] = useState<boolean>(false)
  const [tradingAccounts, setTradingAccounts] = useState<TradingAccountDto[]>([])
  const [dataQuery, setDataQuery] = useState<State>({ skip: 0 })
  const [paginationData, setPaginationData] = useState<PageData<TradingAccountDto[]> | null>(null)

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setLoading(true)
        const response = await tradingAccountsApiClient.getTradingAccountByWalletId(data.id)
        setTradingAccounts(response.items)
        setPaginationData(response)
        setLoading(false)
      } catch (e) {
        console.error(e)
        setLoading(false)
      }
    }
    fetchHistory()
  }, [data.id]) // eslint-disable-line react-hooks/exhaustive-deps

  const sortChange = (event: GridSortChangeEvent) => {
    setDataQuery({ ...dataQuery, sort: event.sort })
    setTradingAccounts(orderBy(tradingAccounts, event.sort))
  }

  if (isLoading) {
    return <Spinner />
  }
  if (!data) {
    return null
  }

  return (
    <Fragment>
      <WalletNavigation tab={WalletTab.TRADING_ACCOUNTS} isEdit={false} data={data} />
      <TableWithExport data={tradingAccounts}>
        <Grid
          resizable
          take={dataQuery.take}
          skip={dataQuery.skip}
          total={paginationData?.totalResults}
          data={tradingAccounts}
          sortable={{
            allowUnsort: true,
            mode: 'multiple',
          }}
          sort={dataQuery.sort}
          onSortChange={sortChange}
          style={{ zIndex: 0 }}
        >
          {clientDetailsTradingAccountWalletDetailsColumn
            .filter((c) => c.show)
            .map((column, idx) => (
              <Column key={idx + 2} {...column} />
            ))}
        </Grid>
      </TableWithExport>
    </Fragment>
  )
}
